<template>
  <div>
    <section class="d-flex justify-content-between align-items-end">
      <div>
        <label for="search">{{ $t("generals.search") }}</label>
        <b-form-input
          id="search"
          v-model="query_params.search"
          @input="searchOffices"
        />
      </div>
      <b-button
        v-b-modal.project-staff-modal
        variant="primary"
        @click="openNewOfficeModal"
      >
        <feather-icon icon="PlusIcon" />
        {{ $t("generals.add") }}
      </b-button>
    </section>
    <b-card class="mt-2">
      <b-table
        :fields="fields"
        :items="GET_PROJECT_STAFF.results"
      >
        <template #head()="data">
          <span>{{ $t(data.label) }}</span>
        </template>
        <template #empty>
          <div class="text-center">
            {{ $t('general.no_records_to_show') }}
          </div>
        </template>
        <template #cell(image)="{ item }">
          <div v-if="item.photo">
            <b-img
              class="w-100"
              thumbnail
              :src="item.photo"
            />
          </div>
        </template>
        <template #cell(description)="{ item }">
          {{ item.description && item.description[$i18n.locale] }}
        </template>
        <template #cell(full_name)="{ item }">
          {{ item.full_name && item.full_name[$i18n.locale] }}
        </template>
        <template #cell(position)="{ item }">
          {{ item.position && item.position[$i18n.locale] }}
        </template>
        <template #cell(actions)="props">
          <div class="d-flex justify-content-between">
            <b-button
              v-b-modal.project-staff-modal
              variant="warning"
              size="sm"
              @click="editStaff(props.item)"
            >
              <feather-icon icon="EditIcon" />
            </b-button>
            <b-button
              variant="danger"
              size="sm"
              @click="deleteStaff(props.item.id)"
            >
              <feather-icon icon="TrashIcon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <div class="d-flex justify-content-between align-items-center flex-wrap mb-75 bg-white p-1">
        <div class="d-flex align-items-center mb-0">
          <span class="text-nowrap text-black ml-1">
            {{ $t('generals.show_from') }}
          </span>
          <b-form-select
            v-model="query_params.page_size"
            :options="['5','10','15']"
            class="mx-1 text-black"
            @change="refresh"
          />
          <!-- <span class="text-nowrap text-black"> {{$t('pagination.entries')}} </span> -->
        </div>
        <div class="mb-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="GET_PROJECT_STAFF.count"
            :per-page="query_params.page_size"
            first-number
            last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @change="refresh"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </div>
    </b-card>
    <project-staff-modal
      :is-edit="editing"
      :def-form-obj="selected_staff"
      @addSuccess="refresh"
    />
  </div>
</template>

<script>
import {
  BFormInput, BCard, BTable, BButton, BImg, VBModal, BPagination, BFormSelect,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { mapActions, mapGetters } from 'vuex'
import projectStaffModal from './components/projectStaffModal.vue'

export default {
  components: {
    BFormInput,
    BCard,
    BTable,
    BButton,
    FeatherIcon,
    BImg,
    projectStaffModal,
    BPagination,
    BFormSelect,
  },
  directives: {
    'b-modal': VBModal,
  },
  data() {
    return {
      currentPage: 1,
      query_params: {
        search: '',
        page_size: 10,
      },
      editing: false,
      selected_staff: {
        description: {},
        position: {},
        full_name: {},
      },
      fields: [
        {
          key: 'id',
          label: 'ID',
          class: 'width-50',
        },
        {
          key: 'image',
          label: 'references.photo',
          class: 'width-150',
        },
        {
          key: 'full_name',
          label: 'clients.full_name',
        },
        {
          key: 'position',
          label: 'references.position',
        },
        {
          key: 'description',
          label: 'objects.description',
        },
        {
          key: 'actions',
          label: 'references.actions',
          class: 'width-150',
        },
      ],
      timeout: 600,
    }
  },
  computed: {
    ...mapGetters('knowledgeBase', ['GET_PROJECT_STAFF']),
  },
  mounted() {
    this.FETCH_PROJECT_STAFF()
  },
  methods: {
    ...mapActions('knowledgeBase', ['FETCH_PROJECT_STAFF', 'DELETE_PROJECT_STAFF']),
    refresh() {
      this.FETCH_PROJECT_STAFF(this.query_params)
    },
    searchOffices() {
      console.log(this.query_params)
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.refresh()
      }, 600)
    },
    openNewOfficeModal() {
      this.editing = false
      this.selected_staff = {
        description: {},
        position: {},
        full_name: {},
      }
    },
    editStaff(staff) {
      this.editing = true
      this.selected_staff = this.$_removeObjectConnection(staff)
    },
    deleteStaff(id) {
      this.$_showAreYouSureModal().then(res => {
        if (res) {
          this.DELETE_PROJECT_STAFF(id).then(() => {
            this.$_successToast(this.$t('generals.deleted'))
            this.refresh()
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      })
    },
  },
}
</script>

<style>

</style>
